module.exports = __webpack_public_path__ + "img/success.d5da3aa4.png";